import { createTheme } from '@mui/material';

const primaryMain = '#0048E5';
const primaryLight = '#59778b';
const secondaryMain = '#592e12';
const disabledColor = '#cacacd';
const disabledColorDark = '#4a4a4d';
const backgroundGrayToggleHeader = '#B4B4B8';

export const dashboardLightTheme = createTheme({
    palette: {
        mode: 'light', // ✅ Added mode
        primary: { main: primaryMain, light: primaryLight },
        secondary: { main: secondaryMain },
        action: {
            disabledBackground: disabledColor,
            disabled: disabledColor
        },
        disabledColor: { main: disabledColor }, // ✅ Added
        backgroundGrayToggleHeader: { main: backgroundGrayToggleHeader },
        background: { // ✅ Added background colors
            default: '#ffffff',
            paper: '#ffffff',
        },
        text: {
            primary: '#222222',
            secondary: '#616161',
        },
        customColors: {
            mainColor: 'linear-gradient(90deg, #0048E5 0%, #625AF5 85%, #7162FC 100%)',
            headerBlue: 'rgba(0, 72, 229, 0.10)',
            contrast: '#000000',
            altopColor: '#EF7F1A',
            pnlRed: '#FF0000',
            pnlGreen: '#009211',
            border: '1px solid rgba(220, 220, 220, 0.80)',
            darkBackground: {
                dark: 'rgba(209, 209, 209, 0.60)',
                borderColor: '1px solid rgba(136, 136, 136, 0.20)',
            },
            mediumBackground: '#e3e3e3',
            lightBackground: '#f1f1f1ff',
            // ✅ Added chart colors for consistency
            chart: {
                axisLabel: "#000000",
                grid: "#e1e3e1",
                title: "#000000",
            },
        },
    },
    typography: {
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: 14,
        body1: { fontSize: '14px' },
        h1: { fontFamily: "'Space Grotesk', sans-serif" },
        h2: { fontFamily: "'Space Grotesk', sans-serif" },
        h3: { fontFamily: "'Space Grotesk', sans-serif" },
        h4: { fontFamily: "'Space Grotesk', sans-serif" },
        h5: { fontFamily: "'Space Grotesk', sans-serif" },
        h6: { fontFamily: "'Space Grotesk', sans-serif" },
    },
});

export const dashboardDarkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: '#ffff', light: '#4A90E2', dark: '#1976D2' }, // ✅ Updated to match main app
        secondary: { main: secondaryMain },
        action: {
            disabledBackground: disabledColorDark, // ✅ Use dark disabled color
            disabled: disabledColorDark
        },
        disabledColor: { main: disabledColorDark }, // ✅ Added
        backgroundGrayToggleHeader: { main: backgroundGrayToggleHeader },
        background: {
            default: '#1a1a1a', // ✅ Updated to match main app
            paper: '#2b2b2b',   // ✅ Updated to match main app
        },
        text: {
            primary: '#ffffff',    // ✅ Updated to match main app
            secondary: '#d6d6d6ff', // ✅ Updated to match main app
        },
        customColors: {
            mainColor: 'linear-gradient(135deg, #1E88E5 0%, #1976D2 100%)', // ✅ Updated gradient for dark theme
            headerBlue: '#333333',  // ✅ Updated to match main app
            contrast: '#ffffff',
            altopColor: '#EF7F1A',
            pnlRed: '#FF0000',
            pnlGreen: '#00C851', // ✅ Brighter green for dark theme
            border: '1px solid #444444', // ✅ Updated border color
            darkBackground: {
                dark: '#0f0f0f',  // ✅ Updated to match main app
                borderColor: '1px solid #444444', // ✅ Updated
            },
            mediumBackground: '#333333', // ✅ Updated to match main app
            lightBackground: '#2b2b2b',  // ✅ Updated to match main app
            // ✅ Added chart colors for dark theme
            chart: {
                axisLabel: "#ffffff",
                grid: "#555555",
                title: "#ffffff",
            },
        },
    },
    typography: {
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontSize: 14,
        body1: { fontSize: '14px' },
        h1: { fontFamily: "'Space Grotesk', sans-serif" },
        h2: { fontFamily: "'Space Grotesk', sans-serif" },
        h3: { fontFamily: "'Space Grotesk', sans-serif" },
        h4: { fontFamily: "'Space Grotesk', sans-serif" },
        h5: { fontFamily: "'Space Grotesk', sans-serif" },
        h6: { fontFamily: "'Space Grotesk', sans-serif" },
    },
});


export const loginTheme = createTheme({
    palette: {
        text: {
            primary: '#000000',
        },
        customButtonColor: {
            main: 'linear-gradient(90deg, #0048E5 0%, #625AF5 85%, #7162FC 100%)'
        }
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    minWidth: 'unset',
                    maxWidth: 'unset',
                    minHeight: 'unset',
                    whiteSpace: 'nowrap',
                    backgroundColor: '#ffffff',
                    '& .MuiSvgIcon-root': {
                        fontSize: 16,
                    },
                },
            },
            defaultProps: {
                SelectProps: {
                    MenuProps: {
                        sx: {
                            maxHeight: '300px !important',
                        },
                    },
                },
            },
        },
    },
    typography: {
        fontFamily: "'Plus Jakarta Sans', sans-serif",
    },

});
